import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useOrganization } from '../contexts/OrganizationContext';
import { supabase } from '../lib/supabase';

export type CompanyPlan = 'projeto' | 'completo';

interface CompanyPlanHook {
  currentPlan: CompanyPlan;
  isPlanoProjeto: boolean;
  isPlanoCompleto: boolean;
  canAccessOperacional: boolean;
  planDisplayName: string;
  loading: boolean;
}

export function useCompanyPlan(): CompanyPlanHook {
  const { user } = useAuth();
  const { organizationId } = useOrganization();
  const [currentPlan, setCurrentPlan] = useState<CompanyPlan>('projeto');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlan = async () => {
      if (!organizationId) {
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('organizations')
          .select('plan')
          .eq('id', organizationId)
          .single();

        if (error) throw error;

        setCurrentPlan(data?.plan || 'projeto');
      } catch (error) {
        console.error('Erro ao buscar plano:', error);
        setCurrentPlan('projeto');
      } finally {
        setLoading(false);
      }
    };

    fetchPlan();
  }, [organizationId]);

  // Listen for plan updates
  useEffect(() => {
    const handlePlanUpdate = (event: CustomEvent<{ plan: CompanyPlan }>) => {
      setCurrentPlan(event.detail.plan);
    };

    window.addEventListener('planUpdated', handlePlanUpdate as EventListener);

    return () => {
      window.removeEventListener('planUpdated', handlePlanUpdate as EventListener);
    };
  }, []);
  
  const isPlanoProjeto = currentPlan === 'projeto';
  const isPlanoCompleto = currentPlan === 'completo';
  
  return {
    currentPlan,
    isPlanoProjeto,
    isPlanoCompleto,
    canAccessOperacional: isPlanoCompleto,
    planDisplayName: currentPlan === 'completo' ? 'Plano Completo' : 'Plano Projeto',
    loading
  };
}